import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { gstActions } from "../../../../../../actions";
import DataTable from "../../../../../common/ui/table/DataTable/DataTable.component";

const GstTax = (props) => {
  const { searchQuery } = props;
  const dispatch = useDispatch();
  const gsts = useSelector((state) => state.gsts);

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "percentage", headerName: "Percentage", width: 150 },
    { field: "country", headerName: "Country", width: 150 },
    { field: "orgid", headerName: "Organization ID", width: 150 },
    { field: "status", headerName: "Status", width: 150 },
  ];

  const recordIdentifier = "country";

  useEffect(() => {
    dispatch(gstActions.getAllParameters());
  }, [dispatch]);

  return (
    <Box>
      {gsts && (
        <DataTable
          loading={gsts?.loading}
          rows={gsts?.items?.data}
          columns={columns}
          recordIdentifier={recordIdentifier}
          actionIdentifier="gstActions"
          search ={searchQuery}
        />
      )}
    </Box>
  );
};

export default GstTax;
